import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=185b803c&scoped=true"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=185b803c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b803c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185b803c')) {
      api.createRecord('185b803c', component.options)
    } else {
      api.reload('185b803c', component.options)
    }
    module.hot.accept("./addBanner.vue?vue&type=template&id=185b803c&scoped=true", function () {
      api.rerender('185b803c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/addBanner.vue"
export default component.exports